import React, { useCallback } from 'react'
import cn from 'classnames'
import { Button, Form, Row, Input, Message } from '@iqueue/ui-kit'
import Logo from '../vector/Logo'
import Auth from '../../api/auth'

export default function UnauthorizedError({ refetch, className }) {
  const [showPassword, setShowPassword] = React.useState(false)
  const [typedPassword, setTypedPassword] = React.useState('')

  const handleSubmit = useCallback(async (formData) => {
    try {
      await Auth.login(formData)

      setTimeout(() => {
        // TODO remove after fix usePermissions
        window.location.reload()
      }, 100)

      return refetch()
    } catch (error) {
      const errorMessage = error?.message || 'Неизвестная ошибка авторизации'

      if (errorMessage.includes('Unauthorized')) {
        Message({
          type: 'error',
          timeout: 5000,
          title: 'Ошибка авторизации',
          subtitle: 'Проверьте свои учетные данные и попробуйте снова.',
        })
      } else {
        Message({
          type: 'error',
          timeout: 5000,
          title: 'Произошла ошибка',
          subtitle: errorMessage,
        })
      }
    }
  }, [refetch])

  return <div
    className={ cn('iq-error-view center', className) }
    style={ {
      background: 'transparent',
      fontWeight: 400,
    } }
  >
    <Form
      allowResubmit
      onSubmit={ handleSubmit }
      style={ {
        maxWidth: '32rem',
        padding: 'var(--iq-grid-spacing) var(--iq-grid-spacing) 0',
        margin: 'var(--iq-grid-spacing) 0 20%',
        borderRadius: 'var(--iq-input-border-radius)',
        boxShadow: 'var(--iq-elevation-2-shadows)',
        background: 'var(--iq-scrollbar-track)',
      } }
    >
      <Logo
        style={ {
          width: '16rem',
          margin: 'var(--iq-grid-spacing) 0 -6.2rem',
          fill: 'var(--iq-color)',
        } }
        beardStyle={ {
          opacity: 0.2,
        } }
      />

      <Row>
        <Input
          autoFocus
          size={ 12 }
          name={ 'username' }
          placeholder={ 'Имя пользователя' }
        />
      </Row>
      <Row>
        <Input
          size={ 12 }
          name={ 'password' }
          placeholder={ 'Пароль' }
          type={ showPassword ? 'text' : 'password' }
          value={ typedPassword }
          onChange={ setTypedPassword }
          actions={ [{
            key: 'eye',
            icon: showPassword ? 'visibility_off' : 'visibility',
            onClick: () => setShowPassword((v) => !v),
          }] }
        />
      </Row>

      <Row justify={ 'center' }>
        <Button
          submit
          primary
          size={ 6 }
          title={ 'Авторизоваться' }
        />
      </Row>
    </Form>
  </div>
}
